import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const erpNext = defineConnector({
  identifier: "erpNext",
  name: "ERPNext",
  tagLine: "Open-source ERP",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ subdomain }) =>
    `https://${subdomain || ".*"}\\.erpnext\\.com/.*`,
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `${app.secret.apiKey}:${app.secret.apiSecret}`,
        scheme: "token",
      },
    ]),
  steps: [
    {
      title: "Get your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In your ERPNext instance, go to **Settings → API Access** and generate an API key and secret pair.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Subdomain",
          required: true,
          target: { kind: "configuration", field: "subdomain" },
          helperText:
            "Your ERPNext subdomain (e.g., `mycompany` from `mycompany.erpnext.com`).",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ subdomain }) =>
      `https://${subdomain}.erpnext.com/api/method/frappe.auth.get_logged_user`,
  },
});
